import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import toast, { Toaster } from 'react-hot-toast';
import { Analytics } from "@vercel/analytics/react"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  
  <React.StrictMode>
    <Analytics />
    <App />
    <Toaster
      position="bottom-right"
      reverseOrder={false}
      toastOptions={{
        style: {
          border: '1px solid hsl(var(--primary) / .5)',
          padding: '16px',
          background: 'hsl(var(--background))',
          color: 'hsl(var(--foreground))',
        },
      }}
    />
  </React.StrictMode></>
);

